<template>
    <main class="support">
        <primary-navigation />
        <nav>
            <div class="constrain bc flex flex-align">
                <a class="destination" @click="tab('about')" :class="{active: active === 'about'}">About</a>
                <!-- <a class="destination" @click="tab('instructors')" :class="{active: active === 'instructors'}">For Instructors</a>
                <a class="destination" @click="tab('students')" :class="{active: active === 'students'}">For Students</a> -->
                <div class="ff"></div>
            </div>
        </nav>
        <article class="constrain bc">
            <section v-if="active === 'about'">
                <h1>
                    Starry Night College Textbook&trade; on the SimCur Interactive Learning Platform
                </h1>
                <p>
                    Starry Night College Textbook&trade; expands on OpenStax&trade; Astronomy digital textbook and
                    seamlessly integrates a fully interactive planetarium, engaging simulations, assignable exercises,
                    and a whole universe for your class to explore.
                </p>
                <p>
                    Students are free to explore and experiment, manipulating the fabric of the universe as never
                    before. Our web-based Learning Platform is accessible on most devices to allow learning to happen
                    from anywhere at anytime.
                </p>
                <p>
                    Starry Night College Textbook&trade; integrates with all major Learning Management Systems (LMS),
                    making it easy for instructors to implement and for students to access. The built-in interactive
                    exercises and assessments synch with your LMS grade-book so you can monitor each student’s learning
                    and progress.
                </p>
                <p>
                    Stunning visualizations and engaging exercises place your students anywhere in known space,
                    dynamically showing the solar system, stars, galaxies, and much more - from the distant past to far
                    into the future.
                </p>
                <p>
                    Since 2004, Starry Night has been a key component of most traditional astronomy 101 textbooks. Now,
                    at long last, the awesome power of the world’s leading astronomy education software comes to
                    OpenStax's digital textbook!
                </p>


                <h2>
                    What Makes Starry Night College Textbook&trade; Great
                </h2>
                <p>
                    Starry Night College Textbook&trade; helps you teach a more satisfying course by making it easy for
                    your students to visually grasp important concepts of astronomy that a traditional textbook alone
                    cannot teach.
                </p>
                <ul>
                    <li>
                        <b>Online Planetarium.</b> The integrated Starry Night browser-based planetarium gives you a
                        powerful, accurate, customizable tool to inspire and engage your students. Starry Night models
                        the universe, placing you anywhere at any time.
                    </li>
                    <li>
                        <b>Assignments.</b> More than 75 assignable astronomy exercises, providing endless interactions.
                        The exercises are seamlessly integrated and correlated to the OpenStax&trade; Astronomy
                        textbook.
                    </li>
                    <li>
                        <b>Astronomy 101 Textbook.</b> Access the OpenStax&trade; Astronomy textbook directly on our
                        Interactive Learning Platform. This provides a tight integration between the textbook, the
                        Starry Night browser-based planetarium, and the assignable exercises. It’s the interactive
                        textbook you always dreamed of having.
                    </li>
                    <li>
                        <b>Embedded Simulations.</b> We enhanced the OpenStax&trade; Astronomy textbook with hundreds of
                        inline simulations that bring the concepts on the page to life. Why only read about it, when you
                        can simulate it.
                    </li>
                    <li>
                        <b>Chapter Quizzes.</b> Over 1000 multiple choice questions that encourage students to apply
                        their understanding of the material. The questions for each chapter are organized by section.
                    </li>
                    <li>
                        <b>Anytime, Anywhere, On Any Device.</b> Runs on your web browser and is accessible on most
                        devices including desktop computers, Chromebooks, and tablets.
                    </li>
                    <li>
                        <b>Up to Date.</b> New discoveries, the latest science, and topical space &amp; astronomy events
                        are made available promptly. Your students can view and interact with the newest comets, space
                        probes, planetary images, and more. You no longer have to work with out-of-date print textbooks,
                        waiting years for a new edition to be updated.
                    </li>
                    <li>
                        <b>Free for Instructors.</b> Access is free for professors and instructors with commitment that
                        Starry Night College Textbook&trade; is a required course material for students.
                    </li>
                    <li>
                        <b>Affordable for Students.</b> Our Interactive Learning Platform provides a complete and rich
                        Astronomy 101 textbook combined with dozens of interactive and engaging exercises and
                        simulations. A one-year license is only $29.95 for students.
                    </li>
                    <li>
                        <b>We’re Here for You.</b> Our dedicated Support Team is there to help with anything you might
                        need to make your course successful. From free training on how to use the Starry Night College
                        Textbook&trade; and walking your LMS Administrator through integration - to help resolve any
                        pesky technical issues that cross your way.
                    </li>
                </ul>

                <h1>Anatomy & Physiology Textbook&trade; on the SimCur Interactive Learning Platform</h1>
                <p>
                    Anatomy & Physiology Textbook seamlessly integrates a 28-chapter Anatomy 101 textbook, engaging
                    virtual 3D simulations, assignable exercises, and a new way for students to learn about the human
                    body by manipulating medically accurate 3D anatomical models.
                </p>
                <p>
                    Technically well done and artistically beautiful, our interactive 3D experiences, help students
                    develop a deeper level of learning. And because our Learning Platform is web-based, it is accessible
                    on most devices to allow learning to happen from anywhere at anytime.
                </p>
                <p>
                    Anatomy & Physiology integrates with all major Learning Management Systems (LMS), making it easy for
                    instructors to implement and for students to access. The built-in interactive exercises and
                    assessments synch with your LMS grade-book so you can monitor each student’s learning and progress.
                </p>
                <h2>What Makes Anatomy & Physiology Textbook Great</h2>
                <p>
                    Anatomy & Physiology Textbook helps you teach a more satisfying course by making it easy for your
                    students to visually grasp important concepts of anatomy that a traditional textbook alone cannot
                    teach.
                </p>
                <ul>
                    <li>
                        <b>Assignments.</b> More than 60 assignable virtual anatomy exercises, providing engaging
                        interactions.
                        The exercises are seamlessly integrated and correlated to the open-source OpenStax Anatomy &
                        Physiology textbook.
                    </li>
                    <li>
                        <b>Anatomy 101 Textbook.</b> Access the OpenStax Anatomy & Physiology textbook directly on our
                        Interactive Learning Platform. This provides a tight integration between the textbook, the
                        simulations, and the assignable exercises. It’s the interactive textbook you always dreamed of
                        having.
                    </li>
                    <li>
                        <b>Graded Quizzes.</b> Over 1000 multiple choice questions that encourage students to apply
                        their
                        understanding of the material. The questions for each chapter are organized by section.
                    </li>
                    <li>
                        <b>Anytime, Anywhere, On Any Device.</b> Runs on your web browser and is accessible on most
                        devices
                        including desktop computers, Chromebooks, and tablets.
                    </li>
                    <li>
                        <b>Free for Instructors.</b> Access is free for professors and instructors with commitment that
                        Anatomy
                        & Physiology Textbook is a required course material for students.
                    </li>
                    <li>
                        <b>Affordable for Students.</b> Our Interactive Learning Platform provides a complete and rich
                        Anatomy
                        101 textbook combined with dozens of interactive and engaging exercises and simulations. A
                        one-year license is only $29.95 for students.
                    </li>
                    <li>
                        <b>We’re Here for You.</b> Our dedicated Support Team is there to help with anything you might
                        need to
                        make your course successful. From free training on how to use the Anatomy & Physiology Textbook
                        and walking your LMS Administrator through integration - to help resolve any pesky technical
                        issues that cross your way.
                    </li>
                </ul>

                <h2>Topics Covered</h2>
                <ul>
                    <li>Structural Organization of the Human Body</li>
                    <li>Cellular and Tissue Level Organization</li>
                    <li>Integumentary System</li>
                    <li>Skeletal System, Fractures and Bone Repair</li>
                    <li>Joints</li>
                    <li>Muscular System</li>
                    <li>Nervous System</li>
                    <li>Endocrine System</li>
                    <li>Fluids and Transport</li>
                    <li>Heart Anatomy and the Cardiovascular System</li>
                    <li>Immune System</li>
                    <li>Respiratory and Digestive Systems</li>
                    <li>Urinary System and Body Fluids</li>
                    <li>Reproductive System</li>
                    <li>And More!</li>
                </ul>

                <h2>
                    Learning Management System (LMS) Integration
                </h2>
                <p>
                    Our Interactive Learning Platform integrates with your preferred LMS such as Canvas, Blackboard,
                    Moodle, G Suite (Google Classroom), Microsoft Teams, Brightspace (D2L), and more.
                </p>
                <ul>
                    <li>
                        <b>Single Sign-On.</b> We automatically recognize the roster information already present in your
                        school LMS. Students and Instructors log in with their existing LMS credentials.
                    </li>
                    <li>
                        <b>Assign Content to the LMS.</b> Instructors can assign exercises from the Starry Night College
                        Textbook&trade; directly to their LMS courses.
                    </li>
                    <li>
                        <b>Sync Grades With the LMS.</b> Results from assessments, quizzes and homework assignments are
                        automatically imported from the Starry Night College Textbook&trade; back into your LMS for use
                        by instructors in grading student performance.
                    </li>
                </ul>
                <div class="connect-lms">
                    <h2><b>Bring Simcur to Your Digital Classroom</b></h2>
                    <p>
                        Ready to deploy <b>Starry Night College</b> or <b>Interactive Anatomy & Physiology</b> in your upcoming course?
                    </p>
                    <ul>
                        <li>
                            <b>For Instructors:</b> If your department has already purchased or adopted one of our textbooks, please share this page link with your campus IT or Canvas/Blackboard support team.
                        </li>
                        <li>
                            <b>For LMS Administrators:</b> Click the link below to initiate the LTI integration, enable Single Sign-On (SSO), and set up automatic gradebook syncing for your institution.
                        </li>
                    </ul>
                    <div class="button" :class="{disabled: onboarding_status === 'connecting'}" @click="connectLms">
                        {{ onboarding_status === 'connecting' ? 'Connecting\u2026' : 'Connect Your LMS' }}
                    </div>
                </div>
            </section>
            <h2>
                Get In Touch
            </h2>
            <div class="contact-form">
                <iframe width="100%" height="800" allowTransparency="true" frameborder="0" scrolling="no"
                    style="border:none" src="https://www.emailmeform.com/builder/embed/f464S2c2va0cdKdJ7"><a
                        href="https://www.emailmeform.com/builder/embed/f464S2c2va0cdKdJ7">Fill out form.</a></iframe>
            </div>
        </article>
    </main>
</template>
<script>
// The Edlink onboarding widget is a plain browser script rather than an npm package,
// so we inject it on demand and share one load across every component that asks for it.
const EDLINK_WIDGET_URL = 'https://ed.link/widgets/edlink@1.0.0.js';

let widget_promise = null;

function loadEdlinkWidget(){
    if(window.Edlink){
        return Promise.resolve(window.Edlink);
    }

    if(widget_promise){
        return widget_promise;
    }

    widget_promise = new Promise((resolve, reject) => {
        const script = document.createElement('script');

        script.src = EDLINK_WIDGET_URL;
        script.async = true;

        script.onload = () => {
            if(window.Edlink){
                return resolve(window.Edlink);
            }

            widget_promise = null;
            reject(new Error('The Edlink widget loaded but did not register itself on `window`.'));
        };

        script.onerror = () => {
            widget_promise = null;
            script.remove();
            reject(new Error('The Edlink widget script could not be downloaded.'));
        };

        document.head.appendChild(script);
    });

    return widget_promise;
}

// Edlink hands back errors in a few different shapes depending on where they originate
// (widget validation, the OAuth round trip, or the Edlink API itself), so normalize them
// before we put anything in front of a user.
function describeEdlinkError(error){
    if(!error){
        return 'An unknown error occurred.';
    }

    if(typeof error === 'string'){
        return error;
    }

    return error.message
        || error.error_description
        || error.description
        || (typeof error.error === 'string' ? error.error : null)
        || 'An unknown error occurred.';
}

export default {
    name: 'About',
    data() {
        return {
            active: 'about',
            // 'connecting' | 'open' | 'connected' | 'cancelled' | 'error', or null before we start.
            onboarding_status: null
        };
    },
    computed: {
        user(){
            return this.$store.state.user;
        }
    },
    mounted(){
        // Not reactive on purpose - Vue should not be walking the widget's internals.
        this.edlink = null;
        this.onboarding = null;
    },
    beforeDestroy(){
        if(this.onboarding){
            this.onboarding.destroy();
            this.onboarding = null;
        }

        this.edlink = null;
    },
    methods: {
        tab(tab) {
            this.active = tab;
        },
        connectLms(){
            // Already built on an earlier click - just reopen it.
            if(this.onboarding){
                this.onboarding.show();
                return Promise.resolve();
            }

            if(this.onboarding_status === 'connecting'){
                return Promise.resolve();
            }

            const client_id = process.env.VUE_APP_EDLINK_CLIENT_ID;

            if(!client_id){
                // A configuration problem, not a user problem - log it loudly and keep the message vague.
                console.error('[Edlink] VUE_APP_EDLINK_CLIENT_ID is not set, so onboarding cannot be started.');
                this.$toasted.error('LMS connection is not available right now. Please contact support.');
                return Promise.resolve();
            }

            this.onboarding_status = 'connecting';

            return loadEdlinkWidget()
            .then(Edlink => {
                this.edlink = new Edlink({client_id});

                this.onboarding = this.edlink.createOnboarding({
                    // We can't assume the provider, and likley shouldn't provide a list
                    // So we leave this unset
                    // Optional: Specify a provider to pre-select it
                    //provider: 'canvas', // Examples: 'canvas', 'schoology', etc.

                    // Optional: Customize the theme
                    //This theme block is NOT optional. Removing it causes the modal to hang
                    //Silently and forever. This is a legit bug on edlink's side
                    theme: {
                        primary_color: '#eb2f06' // Your brand color
                    },

                    // Optional: Tell Edlink the user's email; this creates a better user experience
                    email: this.user.user_email || undefined,

                    onError: this.onOnboardingError,
                    onSuccess: this.onOnboardingSuccess
                });

                // Both of these put the button back to its resting state so the user can retry.
                this.onboarding.on('integrate.cancel', () => {
                    console.log('[Edlink] Onboarding cancelled by user');
                    this.resetOnboardingStatus('cancelled');
                });

                this.onboarding.on('integrate.close', () => {
                    console.log('[Edlink] Onboarding closed');
                    this.resetOnboardingStatus(null);
                });

                // Optional: Listen for errors
                this.onboarding.on('integrate.error', (error) => {
                    console.error('Onboarding error:', error);
                    // Handle error
                });

                // Optional: Listen for successful integration
                this.onboarding.on('integrate.success', (data) => {
                    console.log('Integration successful:', data);
                    // Handle successful integration
                });

                this.onboarding_status = 'open';
                this.onboarding.show();
            })
            .catch(error => this.onOnboardingError(error));
        },
        resetOnboardingStatus(status){
            // `integrate.close` also fires after a success or an error; leave those results alone.
            if(this.onboarding_status === 'connected' || this.onboarding_status === 'error'){
                return;
            }

            this.onboarding_status = status;
        },
        onOnboardingSuccess(data){
            console.log('[Edlink] Onboarding success:', data);

            this.onboarding_status = 'connected';

            this.$toasted.success('Your school account has been connected successfully.');
        },
        onOnboardingError(error){
            const message = describeEdlinkError(error);

            console.error('[Edlink] Onboarding error:', message, error);

            this.onboarding_status = 'error';

            this.$toasted.error(`We could not connect your school account. ${message}`);
        }
    }
}
</script>

<style scoped lang="less">
@import "~@/assets/less/variables";

nav {
    border-bottom: 1px solid var(--border-color);
}

h1 {
    color: var(--primary-text-color);
    margin: 80px 0;
}

h2 {
    color: var(--primary-text-color);
    margin-left: 0;
    margin-right: 0;
}

p,
ul {
    font-size: 15px;
    color: var(--secondary-text-color);
    line-height: 20px;
    margin: 30px 0;
}

article {
    padding-bottom: 100px;
}

li {
    b {
        color: var(--primary-text-color);
    }
}

.connect-lms {
    margin: 30px 0;

    .button {
        display: inline-block;
    }
}

.contact-form {
    border-radius: 3px;
    background: @f;
    padding: 0 20px;
    margin-top: 20px;
}
</style>
